import { getRequest } from "../config/axiosConfig";

class CmsService {
  async getCmsContent(country: string, brand: string) {
    return await getRequest(`cms-content/${country}/${brand}`);
  }
}

export default CmsService;
